// @ts-strict-ignore
import { captureException } from '@sentry/nextjs';
import api from 'src/utils/api';
import WithErrorHandling from 'src/components/hoc/withErrorHandling';
import { setAlert } from 'src/components/alert/actions';
import { PageContext } from 'src/constants/types';
import RequestResetPage from 'src/modules/resetPassword/requestResetPage';
import ResetPasswordPage from 'src/modules/resetPassword/resetPasswordPage';

const Page = ({ code, isValidCode }: { code: string; isValidCode: boolean }) => {
  if (isValidCode) return <ResetPasswordPage code={code} />;
  return <RequestResetPage />;
};

Page.getInitialProps = async ({ query: { code }, store: { dispatch } }: PageContext) => {
  let isValidCode = false;

  if (code) {
    try {
      const response = await api.getPublic(`password-reset/${code}`);
      if (response) {
        isValidCode = true;
      }
    } catch (ex) {
      dispatch(setAlert(ex.response.data.message, 'danger', 'none'));
      captureException(ex);
    }
  }

  return { code, isValidCode };
};

export default WithErrorHandling(Page);
